import { BASE_URL } from "config";

import * as base from './_base';


export const endpoints = {
  list: `${BASE_URL}/api/v1/slider/`,
  detail: (id) => `${BASE_URL}/api/v1/slider/${id}/`,
};

export const sliderListLoad = (token, payload) => base.ListLoad(endpoints.list, token, payload);
export const sliderDetailLoad = (token, { id }) => base.DetailLoad(endpoints.detail, token, { id });
export const sliderUpdate = (token, data) => base.Update(endpoints.list, endpoints.detail, token, data);
export const sliderDelete = (token, data) => base.Delete(endpoints.detail, token, data);
